import LoginModule from "@/modules/Login";

function LoginPage() {
  return <LoginModule />;
}

export default LoginPage;
